<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">E-mails em massa</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>

      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">E-mails</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList "></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Titulo</th>
                    <th scope="col" class="border-0">Grupo de Email</th>
                    <th scope="col" class="border-0">Enviado por</th>
                    <th scope="col" class="border-0 text-center">Data do envio</th>
                    <th scope="col" class="border-0" v-if="$isAuthorize('Emailing', 'Get')"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(email, index) in emails" :key="index">
                    <td></td>
                    <td class="text-left">{{ GetTitle(email.Title) }}</td>
                    <td>{{ email.GroupType.Name || "Nenhum" }}</td>
                    <td>{{ email.UserInternal.Name }}</td>
                    <td class="text-center">{{ email.CreatedDate | date }}</td>
                    <td v-if="$isAuthorize('Emailing', 'Get')">
                      <b-button
                        size="sm"
                        v-on:click="OpenEmail($event, email.Id)"
                        title="Visualizar o e-mail enviado"
                        v-b-tooltip.hover
                        >
                        <i class="fas fa-eye m-0 p-0"></i>
                      </b-button>
                     
                    </td>
                  </tr>
                  <tr v-if="emails == undefined || emails == null || emails.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <the-mask
            :mask="['######']"
            class="form-control"
            v-on:keyup.enter.native="Filter()"
            type="tel"
            v-model="filter.Id" />
        </d-col>

        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Destinatário"
            type="text"
            v-model="filter.Recipient"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select
            v-model="filter.IdGroupType"
          >
            <option :value="null" selected>Grupo de Envio</option>
            <option
              v-for="group in groupTypes"
              v-bind:value="group.Id"
              v-bind:key="group.Id"
            >{{group.Name}}</option>
          </d-select>
        </d-col>

        <d-col md="6" class="form-group">
          <d-select
            v-model="filter.IdUserInternal"
            :value="null"
          >
            <option :value="null" selected>Usuário do Internal</option>
            <option
              v-for="user in users"
              v-bind:key="user.Id"
              v-bind:value="user.Id"
            >{{user.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Titulo"
            type="text"
            v-model="filter.Title"
            v-on:keyup.enter="Filter()"
          />
        </d-col>

        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Conteúdo"
            type="text"
            v-model="filter.Content"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Emailing', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo e-mail"
      v-b-tooltip.hover
      v-on:click="NewEmailing($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";

export default {
  name: "emailing",
  data: function() {
    return {
      countFilter: 0,
      emails: [],
      filter: {
        Content: null,
        Id: 0,
        IdGroupType: null,
        IdUserInternal: null,
        Recipient: null,
        Title: null,
      },
      groupTypes: [],
      loadingList: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      users: [],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListEmails();
    },
    "pagination.RowsPerPage": function() {
      this.ListEmails();
    },
  },
  beforeMount() {
    this.ListEmails();
  },
  created() {
    this.ListEmailingGroupType();
  },
  mounted() {
    this.ListEmails();
    this.ListUserInternal();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListEmails();
    },
    ResetFilter: function() {
      this.filter = {
        Content: null,
        Id: 0,
        IdGroupType: null,
        IdUserInternal: null,
        Recipient: null,
        Title: null,
      };
      this.ListEmails();
    },
    NewEmailing: function() {
      this.$router.push({
        name: "email",
        query: { id: 0 }
      });
    },
    ListEmails: function() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Content)) this.countFilter++
      if (hasValue(this.filter.Id)) this.countFilter++
      if (hasValue(this.filter.IdGroupType)) this.countFilter++
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++
      if (hasValue(this.filter.Recipient)) this.countFilter++
      if (hasValue(this.filter.Title)) this.countFilter++
      let data = {
        ...this.pagination,
        "Object.Content": this.filter.Content,
        "Object.Id": this.filter.Id,
        "Object.GroupType.Id": this.filter.IdGroupType,
        "Object.UserInternal.Id": this.filter.IdUserInternal,
        "Object.Recipient": this.filter.Recipient,
        "Object.Title": this.filter.Title,
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListEmailing", { params: data })
        .then(response => {
          this.emails = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os e-mails. Tente novamente.",
            "danger",
            "Erro ao listar e-mails",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ListEmailingGroupType: function() {
      this.$store
      .dispatch("ListEmailingGroupType", {})
      .then(response => {
        this.groupTypes = response;
      })
      .catch(error => {
        this.$makeToast(
          "Um erro ocorreu ao listar os grupos de e-mail. Tente novamente.",
          "danger",
          "Erro ao listar os grupos de e-mail",
          error
        );
      })
    },
    ListUserInternal: function() {
      this.$store
        .dispatch("ListUserInternal", { params: {} })
        .then(response => {
          this.users = response.Objects;
          this.users.sort(this.SortAlpha);
        })
        .catch(error => {
          this.$makeToast(
            "Tente novamente atualizando a página.",
            "warning",
            "Erro ao listar os usuários",
            error
          );
        })
    },
    OpenEmail: function(ev, id) {
      ev.preventDefault();
      if (id) {
        this.$router.push({
          name: "email",
          query: { id }
        });
      }
    },
    GetTitle(title) {
      if (hasValue(title)) return title;
      else return "-- Sem título --";
    },
    SortAlpha: function(a,b) { return a.Name.localeCompare(b.Name); },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/emailing.vue